import { createFileRoute } from '@tanstack/react-router';
import { z } from 'zod';
import { BenefitUserDetailPage } from './BenefitUserDetailPage';

const breadCrumbItemSchema = z.object({
  label: z.string(),
  to: z.string(),
  params: z.record(z.string(), z.string()).optional(),
  search: z.record(z.string(), z.unknown()).optional(),
});

const searchSchema = z.object({
  breadCrumsInfo: z.array(breadCrumbItemSchema).optional(),
});

export const Route = createFileRoute('/_protected/admin/benefits/$benefitId/users/$userId/')({
  component: BenefitUserDetailPage,
  validateSearch: searchSchema,
});
